var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47979 12.1258C6.8031 12.7744 5.90661 13.1293 4.9523 13.1293L4.95082 13.1292C2.97709 13.1292 1.375 11.5893 1.375 9.70153V4.61329C1.375 3.8288 2.03725 3.19397 2.85564 3.19397C3.67403 3.19397 4.33628 3.8288 4.33628 4.61329V9.70153C4.33628 10.0287 4.61392 10.2906 4.95082 10.2906C5.11422 10.2906 5.27038 10.2269 5.38461 10.1174L15.5048 0.416348C16.0817 -0.136687 17.023 -0.140874 17.6 0.416348C18.1769 0.973571 18.1769 1.87171 17.6 2.42475L7.47979 12.1258ZM4.40144 19.5758L14.5216 9.87476C15.1983 9.2261 16.0948 8.87128 17.0491 8.87128C19.0228 8.87128 20.6249 10.4112 20.6249 12.299V17.3872C20.6249 18.1717 19.9627 18.8066 19.1443 18.8066C18.3259 18.8066 17.6637 18.1717 17.6637 17.3872V12.299C17.6637 11.9719 17.386 11.7099 17.0491 11.7099C16.8857 11.7099 16.7295 11.7737 16.6153 11.8832L6.49514 21.5842C6.20742 21.8614 5.83 22 5.44829 22C5.06803 22 4.69063 21.8614 4.40144 21.5842C3.82451 21.027 3.82451 20.1288 4.40144 19.5758Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.6f273dd703ba2002969cc7db23f5d2b7.svg";
export { ForwardRef as ReactComponent };